import React from "react";
import { MdCompareArrows } from "react-icons/md";
import Button from "components/Button";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import {
  SecondaryPrice,
  DefaultText,
  MainPrice,
  shadow,
  smallShadow,
} from "theme/GlobalElements";
import { useDispatch } from "react-redux";
import { showRootModal } from "features/rootModal/rootModalSlice";
import { addProductToCompare } from "features/compare/compareSlice";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { colors } from "theme/Theme";
import { Product } from "features/ProductReel/types";
import { buttonType } from "components/Button/Button";
import { PageWithFilterType } from "features/Filters/types";
import DualPrice, { EuroPrice } from "components/Price";

interface PriceAndButtonsProps {
  fetchedProduct: Product;
}

const PriceAndButtons: React.FC<PriceAndButtonsProps> = ({
  fetchedProduct,
}) => {
  const dispatch = useDispatch();

  const addItem = () => {
    if (fetchedProduct.quantity > 0) {
      dispatch(
        showRootModal({
          modalType: "CHECKOUT",
          modalProps: {
            item: fetchedProduct,
            pageType: PageWithFilterType.category,
          },
        })
      );
    }
  };

  const addItemForComparison = (e: any) => {
    e.stopPropagation();
    if (fetchedProduct) {
      dispatch(addProductToCompare(fetchedProduct));
    }
  };

  return (
    <PriceAndButtonsContainer>
      <Prices>
        {fetchedProduct.price_promotion ? (
          <PriceContainer>
            <SecondaryPrice className="text-body">
              <EuroPrice
                bgn={fetchedProduct.price}
                eur={fetchedProduct.price_eur}
              />
            </SecondaryPrice>
            <MainPrice className="text-lg">
              <DualPrice
                bgn={fetchedProduct.price_promotion}
                eur={fetchedProduct.price_promotion_eur}
              />
            </MainPrice>
          </PriceContainer>
        ) : (
          <PriceContainer>
            <MainPrice className="text-lg">
              <DualPrice
                bgn={fetchedProduct.price}
                eur={fetchedProduct.price_eur}
              />
            </MainPrice>
          </PriceContainer>
        )}
        <DDSPrice className="text-xs">{`Цена ${
          fetchedProduct.description.free_mounting
            ? "с включен монтаж и ДДС"
            : "без монтаж с включено ДДС"
        }`}</DDSPrice>
      </Prices>
      <ButtonsContainer>
        <Button
          onClick={addItem}
          title="Добави"
          type={buttonType.blueBtn}
          classNames={"product-details-button"}
          disabled={fetchedProduct.quantity <= 0}
        >
          <HiOutlineShoppingCart
            style={{
              width: 24,
              height: 24,
              color: "white",
              marginRight: "5px",
            }}
          />
        </Button>
        <Button
          onClick={addItemForComparison}
          title="Сравни"
          type={buttonType.defaultBtn}
          classNames={"product-details-button margin"}
        >
          <MdCompareArrows style={{ width: 24, height: 24, fill: "black" }} />
        </Button>
      </ButtonsContainer>
    </PriceAndButtonsContainer>
  );
};

const PriceAndButtonsContainer = styled.div`
  margin: 20px 10px 30px 10px;
  flex: 0 0 100%;
  display: flex;
  flex-flow: column;
  align-items: center;

  @media only screen and (${device.tablet}) {
    margin: 10px 0;
    flex-flow: row nowrap;
  }

  @media only screen and (${device.laptop}) {
    flex-flow: column;
    align-items: flex-start;
    margin: 20px 0;
  }

  @media only screen and (${device.laptopL}) {
    flex: 1;
    margin-right: 10px;
  }
`;

const Prices = styled.div``;

export const PriceContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  @media only screen and (${device.tablet}) {
    justify-content: flex-start;
    flex-flow: column;
  }

  @media only screen and (${device.laptop}) {
    flex-flow: row nowrap;
  }
`;

export const DDSPrice = styled(DefaultText)`
  font-weight: bold;
  color: ${colors.grayest};
  margin-bottom: 10px;

  @media only screen and (${device.laptopL}) {
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex: 2;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  .product-details-button {
    ${smallShadow}

    &.margin {
      margin-top: 0;
      margin-left: 10px;
    }
  }

  @media only screen and (${device.laptop}) {
    margin: 10px 0;
  }
`;

export default PriceAndButtons;
